import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

const pharmacyClaimsRouteSearchSchema = z.object({
  page: zodPage,
  tab: z.enum(['notClosedByPharmacy', 'archivedByPharmacy']).default('notClosedByPharmacy'),
  search: z.string().optional(),
});

export const pharmacyClaimsRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/claims',
  validateSearch: pharmacyClaimsRouteSearchSchema,
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/pharmacy/Cases/PharmacyCasesPage/PharmacyCasesPage').then((d) => d.Route)
);
